import React, { Component, Suspense } from 'react';
import { getBiCallback, shouldRenderChild, RicosEngine } from 'ricos-common';
import { RichContentViewer } from 'wix-rich-content-viewer';
import { Version } from 'wix-rich-content-common';
import RicosModal from './modals/RicosModal.js';
import { getContentSummary } from 'wix-rich-content-common/libs/contentAnalytics';
import './modals/fullscreen/FullscreenProvider.js';
import 'wix-rich-content-fullscreen/libs/getImagesData';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
class RicosViewer extends Component {
  constructor(props) {
    super(props);
    this.getLocale = () => {
      const { children, locale } = this.props;
      return (children == null ? void 0 : children.props.locale) || locale;
    };
    this.onPreviewExpand = () => this.setState({ isPreviewExpanded: true });
    this.setRef = (ref) => ref && (this.viewerRef = ref);
    this.loadTextSelection = () => {
      const { textSelectionToolbar, isMobile } = this.props;
      const needTextSelectionToolbar = textSelectionToolbar && !isMobile;
      if (needTextSelectionToolbar && !this.state.TextSelectionToolbar) {
        const TextSelectionToolbar = React.lazy(() => import('./TextSelectionToolbar.js'));
        this.setState({ TextSelectionToolbar });
      }
    };
    this.loadLinkPreviewPopover = () => {
      const { linkPreviewPopoverFetchData, isMobile } = this.props;
      const needLoadLinkPreviewPopover = linkPreviewPopoverFetchData && !isMobile;
      if (needLoadLinkPreviewPopover && !this.state.LinkPreviewPopover) {
        const LinkPreviewPopover = React.lazy(() => import('./LinkPreviewPopover.js'));
        this.setState({ LinkPreviewPopover });
      }
    };
    this.onMouseOver = () => {
      this.loadTextSelection();
      this.loadLinkPreviewPopover();
    };
    this.getBiCallback = getBiCallback.bind(this);
    this.state = {
      isPreviewExpanded: false,
      localeData: { locale: props.locale },
      remountKey: false
    };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, errorInfo) {
    console.error({ error, errorInfo });
  }
  componentDidMount() {
    var _a, _b, _c, _d;
    const { children } = this.props;
    const onViewerLoaded = this.getBiCallback("onViewerLoaded");
    const isPreview = ((_a = children == null ? void 0 : children.props.helpers) == null ? void 0 : _a.isPreview) || ((_c = (_b = this.props._rcProps) == null ? void 0 : _b.helpers) == null ? void 0 : _c.isPreview);
    const content = this.props.content || (children == null ? void 0 : children.props.initialState) || ((_d = this.props._rcProps) == null ? void 0 : _d.initialState);
    const { pluginsCount } = content && getContentSummary(content) || {};
    onViewerLoaded == null ? void 0 : onViewerLoaded({
      isPreview: !!(isPreview == null ? void 0 : isPreview()),
      version: Version.currentVersion,
      pluginsCount,
      url: document.URL,
      contentId: content.ID
    });
  }
  render() {
    var _b, _c, _d, _e;
    const _a = this.props, { children, seoSettings, linkPreviewPopoverFetchData } = _a, props = __objRest(_a, ["children", "seoSettings", "linkPreviewPopoverFetchData"]);
    const { isPreviewExpanded, localeData, TextSelectionToolbar, LinkPreviewPopover } = this.state;
    try {
      if (this.state.error) {
        (_c = (_b = this.props).onError) == null ? void 0 : _c.call(_b, this.state.error);
        return null;
      }
      const child = children && shouldRenderChild("RichContentViewer", children) ? children : /* @__PURE__ */ React.createElement(RichContentViewer, null);
      return [
        /* @__PURE__ */ React.createElement(
          RicosEngine,
          __spreadValues({
            key: "viewer",
            RicosModal,
            isPreviewExpanded,
            onPreviewExpand: this.onPreviewExpand,
            getContentId: () => {
              var _a2;
              return (_a2 = props.content) == null ? void 0 : _a2.ID;
            },
            isViewer: true
          }, props),
          React.cloneElement(child, __spreadValues({
            seoMode: seoSettings,
            setRef: this.setRef,
            onMouseOver: this.onMouseOver
          }, localeData))
        ),
        TextSelectionToolbar ? /* @__PURE__ */ React.createElement(Suspense, { key: "TextSelectionToolbar", fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(
          TextSelectionToolbar,
          {
            onButtonClick: this.getBiCallback("onViewerAction"),
            container: this.viewerRef
          }
        )) : null,
        LinkPreviewPopover ? /* @__PURE__ */ React.createElement(Suspense, { key: "LinkPreviewPopover", fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(
          LinkPreviewPopover,
          {
            fetchUrlPreviewData: linkPreviewPopoverFetchData,
            container: this.viewerRef
          }
        )) : null
      ];
    } catch (e) {
      (_e = (_d = this.props).onError) == null ? void 0 : _e.call(_d, e);
      return null;
    }
  }
}
RicosViewer.defaultProps = {
  onError: (err) => {
    throw err;
  },
  locale: "en"
};

export { RicosViewer };
//# sourceMappingURL=RicosViewer.js.map
